export default __webpack_public_path__ + "static/media/Arch_AWS-Lambda_48.fe4ccff2.svg";